import type { IContextualMenuItem } from "@fluentui/react/lib/ContextualMenu";
import * as React from "react";
import { MenuGroupHeader } from "@fluentui/react-components";
import { useAppMenuItemCustomStyles } from "./useAppMenuItemStyles";

export const MenuHeaderWithActionV9 = (
  item: IContextualMenuItem,
  _onDismiss?: (
    ev?: Event | React.MouseEvent | React.KeyboardEvent,
    dismissAll?: boolean
  ) => void
) => {
  const classes = useAppMenuItemCustomStyles();
  const onClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
    item.data.action.onClick(ev);
    _onDismiss?.(ev, true);
  };
  return (
    <MenuGroupHeader className={classes.headerWithActionButton}>
      {item.text}
      <button className={classes.headerActionButton} onClick={onClick}>
        {item.data.action.text}
      </button>
    </MenuGroupHeader>
  );
};
